import { render, staticRenderFns } from "./ReturnRules.vue?vue&type=template&id=3c134e12&scoped=true"
import script from "./ReturnRules.vue?vue&type=script&lang=js"
export * from "./ReturnRules.vue?vue&type=script&lang=js"
import style0 from "./ReturnRules.vue?vue&type=style&index=0&id=3c134e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c134e12",
  null
  
)

export default component.exports